<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs @change="callback" :default-active-key="$route.query.active || '1'">
        <a-tab-pane key="1" tab="经销商级别">
          <div class='mb25 s_flex_ali'>
            <span class='mr15'>
              <a-button type="primary"
                v-has:dealerLevelCreate="()=> {$router.push('/customer/dealer/level_add?type=add')}">
                <PlusOutlined />
                添加级别
              </a-button>
            </span>
            <p class="s_fonts16 s_c333">警告：经销商级别一经启用，请不要随意修改！最多添加10个级别</p>
          </div>
          <a-table :pagination='false' :loading='listLoading' bordered rowKey='level_id' :columns='columns'
            :data-source='data'>
            <template v-slot:is_sub_store="{ record }">
              <p>{{record.is_sub_store?'允许':'不允许'}}</p>
            </template>
            <template v-slot:is_sub_dealer="{ record }">
              <p>{{record.is_sub_dealer?'允许':'不允许'}}</p>
            </template>
            <template v-slot:is_deliver_allow="{ record }">
              <p>{{record.is_deliver_allow?'允许':'不允许'}}</p>
            </template>
            <template v-slot:action="{ record }">
              <a v-has:dealerLevelEdit="()=> {$router.push('/customer/dealer/level_edit?type=edit&id='+record.level_id)}"
                href="javascript:;">修改</a>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="经销商结构树">
          <a-row type="flex" justify="space-around">
            <a-col :span="11">
              <div class="s_wid100 s_bor_cbed s_bor10 s_ptb0lr24">
                <a-tree show-icon :tree-data="treeData" @expand="onExpand" defaultExpandAll
                  :replace-fields="replaceFields" @select="onSelect">
                  <template v-slot:boss>
                    <UserOutlined />
                  </template>
                  <template v-slot:agent>
                    <TeamOutlined />
                  </template>
                </a-tree>
              </div>
            </a-col>
            <a-col :span="11">
              <div class="s_wid100 s_bor_cbed s_bor10 s_over_h" v-if='show'>
                <div class="s_hei60 s_wid100 s_ptb0lr24 s_bf58 s_flex_bian_c">
                  <p class="s_c333 s_fonts18 s_font_b">详细信息</p>
                  <EditOutlined
                    @click="()=> {$router.push('/customer/dealer/dealer_add?active=2&type=edit&id='+dealerMore.dealer_id)}"
                    style='font-size: 20px;' />
                </div>
                <div class="p-24">
                  <p class="s_c333 s_lin_h35">经销商资料状态：{{dealerMore.status ? '正常':'禁用'}}</p>
                  <p class="s_c333 s_lin_h35">经销商编号：{{dealerMore.dealer_sn}}</p>
                  <p class="s_c333 s_lin_h35">经销商名称：{{dealerMore.dealer_name}}</p>
                  <p class="s_c333 s_lin_h35">手机号：{{dealerMore.leader_phone}}</p>
                  <p class="s_c333 s_lin_h35">负责人：{{dealerMore.leader_name}}</p>
                  <p class="s_c333 s_lin_h35">
                    地区：{{dealerMore.province_name}}{{dealerMore.city_name}}{{dealerMore.region_name}}</p>
                  <p class="s_c333 s_lin_h35">详细地址：{{dealerMore.address}}</p>
                  <p class="s_c333 s_lin_h35">经销商级别：{{dealerMore.level_name}}</p>
                  <p class="s_c333 s_lin_h35">上级经销商：{{dealerMore.parent_dealer_name}}</p>
                  <p class="s_c333 s_lin_h35">创建日期：{{dealerMore.create_time}}</p>
                  <div class="s_c333 s_lin_h35 clearfix">
                    <p class="fl">销售区域：</p>
                    <div class='fl'>
                      <p v-for='(item,index) in dealerMore.sale_area_text' :key='index'>
                        {{item.country_name}}{{item.province_name}}{{item.city_name}}{{item.area_name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
  import { PlusOutlined, UserOutlined, EditOutlined, TeamOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getDealerLevelList, delLevel, getTree, getDealerMore } from "@/api/dealer";
  import { iscode } from "@/utils/app";


  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
  };
  export default {
    components: { PlusOutlined, UserOutlined, EditOutlined, TeamOutlined },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        show: false,
        dealerMore: {},
        listLoading: false,
        content: '通过邀请注册的经销商资料，需要审核通过后才能正式添加。',
        replaceFields: {
          title: 'dealer_name',
          key: 'id'
        },
        // slots: { icon: 'boss' },
        // slots: { icon: 'agent' },
        treeData: []
      });
      let columns = [
        {
          title: "级别",
          dataIndex: "level",
          key: "level",
        },
        {
          title: "级别名称",
          dataIndex: "level_name",
          key: "level_name",
        },
        {
          title: "门店管理",
          key: "is_sub_store",
          slots: { customRender: "is_sub_store" },
        },
        {
          title: "下级经销商管理",
          dataIndex: "is_sub_dealer",
          slots: { customRender: "is_sub_dealer" },
        },
        {
          title: "防窜货管理",
          dataIndex: "is_deliver_allow",
          slots: { customRender: "is_deliver_allow" },
        },
        {
          title: "经销商数量",
          dataIndex: "dealer_count",
          key: "dealer_count",
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          customRender: ({ text, record }) => {
            return record.remark ? record.remark : '-'
          },
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");


      //删除级别
      const levelDel = (e) => {
        $Modal.confirm({
          centered: true,
          title: '经销商级别删除',
          content: '删除后该级别将无法恢复，您确定要删除该级别吗？', onOk: async () => {
            let res = await delLevel(e.level_id).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      //获取结构树
      const getTreeList = async () => {
        let res = await getTree().then(res => res.data);
        if (iscode(res)) {
          state.treeData = [{ dealer_name: '总部', id: 0, children: res.data }]
          state.treeData = caclChildRenLength(state.treeData, [])
        } else {
          message.error(res.msg);
        }
      }
      const caclChildRenLength = (list) => {
        list.forEach(element => {
          if (element.children) {
            element.dealer_name = element.dealer_name + "(" + element.children.length + ")"
            element.children = caclChildRenLength(element.children)
          } else {
            element.dealer_name = element.dealer_name + "(" + 0 + ")"
          }
        });
        return list
      }
      //获取经销商详情
      const getMore = async (id) => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getDealerMore(id).then(res => res.data).catch((error) => error);
        if (iscode(res)) {
          state.dealerMore = res.data
          state.show = true
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      }

      const pageSetUp = ref(null)
      const salesmanPageSetup = ref(null)

      const callback = (e) => {
        if (e == 3) {
          if (!pageSetUp.value) return
          pageSetUp.value.initData()
        } else if (e == 4) {
          if (!salesmanPageSetup.value) return
          salesmanPageSetup.value.initData()
        } else {
          return
        }
      }
      const onSelect = (keys) => {
        if (keys[0] !== 0) {
          getMore(keys[0])
        }

      }
      const onExpand = () => {
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getDealerLevelList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        initData(search.value);
        getTreeList();
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        levelDel,
        onSelect,
        onExpand,
        callback,
        getMore,
        pageSetUp,
        salesmanPageSetup
      };
    },
  };
</script>